export default __webpack_public_path__ + "static/van-8aedc295e3e44098c97322c489633a09.png";